var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "twitter_svg__a",
    width: 16,
    height: 15,
    x: 6,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22 7H6v14.5h16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#twitter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.587 7h2.453l-5.387 6.153 6.294 8.347h-4.939l-3.867-5.072L8.715 21.5H6.26l5.707-6.581L5.941 7h5.062l3.493 4.634zm-.859 13.055h1.36l-8.8-11.664H8.827z"
  }))));
};
export default SvgTwitter;